module.exports = __webpack_public_path__ + "img/bttn-back.91bead28.svg";